import { Fragment } from "react";
import { Link } from "react-router-dom";
import { generatePath, matchPath, useLocation } from 'react-router';
import { useAccessContext } from "../AccessLevels/AccessContext.js";
import { TopMenuStyled } from "./styled/TopMenuStyled.js";

function TopMenu(props) {
    const {
        className,
        items,
        level = 'first',
    } = props;

    const { pathname } = useLocation();
    const { checkAccess } = useAccessContext();

    return <TopMenuStyled level={level} className={className}>
        {
            items.map(item => <Fragment key={item.path}>
                {
                    (!item.access || checkAccess(item.access)) &&
                    <Link to={generatePath(item.path)}
                          className={`item ${!!matchPath(pathname, {
                              exact: item.exact || level === 'second',
                              path: item.path
                          }) ? 'active' : ''}`}>{item.title}</Link>
                }
            </Fragment>)
        }
    </TopMenuStyled>
}

export default TopMenu;
